<template>
  <v-card flat>
    <v-toolbar dense flat tile color="white">
      <v-btn depressed small color="primary" @click="adicionarConta">Adicionar Conta Bancaria</v-btn>
    </v-toolbar>

    <v-divider></v-divider>

    <v-card-text class="pa-0">
      <v-data-table
        mobile-breakpoint="0"
        hide-default-footer
        disable-pagination
        disable-sort
        fixed-header
        no-data-text="Para adicionar uma conta, clique no botão acima"
        height="383px"
        :headers="headers"
        :items="$store.state.fornecedores.fornecedor.contas"
      >

       <template #item.banco="{ item }">
        {{ item.banco.codigo }} - {{ item.banco.descricao }}
       </template>

        <template #item.opcoes="{ item }">
          <v-btn icon @click.stop="compartilhar(item)">
            <v-icon>mdi-share-variant</v-icon>
          </v-btn>
          <v-btn icon @click.stop="editar(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon @click.stop="excluir(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>

      </v-data-table>
    </v-card-text>
    <ModalConta ref="modalconta"></ModalConta>

    <z-dialogo-sim-nao 
      ref="dialogoExcluir" 
      titulo="Remover Conta" 
      botaoSim="Remover" 
      botaoNao="Cancelar" 
      :loading="excluindo"
    >
      A conta será excluída. Deseja remover?
    </z-dialogo-sim-nao>
  </v-card>
</template>

<script setup>
import { onMounted, ref, getCurrentInstance, inject } from "vue";
import ModalConta from "./modais/ModalConta.vue";

const { proxy } = getCurrentInstance();
const $store = proxy.$store;
const $notificacao = inject('notificacao');

const headers = [
  { text: 'Banco', value: 'banco' },
  { text: 'Agencia', value: 'agencia' },
  { text: 'Conta', value: 'numero_conta'},
  { text: 'Titular', value: 'titular' },
  { text: 'Opções', value: 'opcoes', width: '200px', align: 'center' },
]

const modalconta = ref(null);
const excluindo = ref(false);
const dialogoExcluir = ref(false);

function adicionarConta() {
  modalconta.value.abrir();
}

async function editar(conta) {
  await $store.dispatch('fornecedores/exibirConta', conta.id);
  modalconta.value.abrir();
}

async function excluir(conta) {

  const resposta = await dialogoExcluir.value.abrir();

  if (resposta == false) {
    return;
  }

  excluindo.value = true;

  try {
    await $store.dispatch('fornecedores/excluirConta', conta.id);

    $notificacao.notificar("Conta excluída com sucesso");
  } catch (error) {
    $notificacao.error("Não foi possível excluir a conta", error);
    throw error;
  } finally {
    dialogoExcluir.value.fechar()
    excluindo.value = false;
  }
}

</script>

<style lang="scss" scoped>

</style>